import { h, render } from 'preact';

import TemplateAd from './components/TemplateAd';

function Template(props) {
  return <TemplateAd {...props} />
}

export default Template;